import { render, staticRenderFns } from "./MenuAddViewModal.vue?vue&type=template&id=098f0237&"
import script from "./MenuAddViewModal.vue?vue&type=script&lang=js&"
export * from "./MenuAddViewModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuAddViewModal.vue?vue&type=style&index=0&id=098f0237&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports